const callGtag = (...allArgs) => {
  if (window.gtag) {
    try {
      window.gtag(...allArgs);
    } catch (error) {
      console.warn('could not call gtag', error);
    }
  } else {
    console.warn('could not call gtag, window.gtag not found');
  }
};

export {
  callGtag,
};
